export const API_BASE = import.meta.env.VITE_API_BASE;
export const API_LLM_BASE = import.meta.env.VITE_API_LLM_BASE;
export const API_GRAPH_BASE = import.meta.env.VITE_API_GRAPH_BASE;
export const ZBRAIN_BASE_URL = import.meta.env.VITE_ZBRAIN_BASE_URL;
export const STORAGE_BASE = import.meta.env.VITE_STORAGE_BASE;
export const ENVIRONMENT_TYPE = import.meta.env.VITE_ENVIRONMENT_TYPE;
export const ADMIN_LIST = import.meta.env.VITE_ADMIN_EMAIL;
export const REQUEST_VIEW_USERS = import.meta.env.VITE_REQUEST_VIEW_USERS;
export const SAS_TOKEN = import.meta.env.VITE_SAS_TOKEN;

export const COPILOT_APP_ID = '6856774964336a971d20a63e';
export const KEY_INFO_APP_ID = '681c9ebf762adb28041bf0ef';
export const KEY_INFO_API_KEY =
  'za-U2FsdGVkX18QbCkMUnhuH7RESMGcxe9Gm2CCCtv1ZMh4gbSEzSYjSCLZ8az9S9nG3yw/iyJMzZWHB7rYEdabgcy76lx7e3of+MRQdYTqG72OKKw0IHHzvRGDVQXWYBDU';
export const BLUEPRINT_EVALUATE_API_KEY =
  'za-U2FsdGVkX18QbCkMUnhuH7RESMGcxe9Gm2CCCtv1ZMh4gbSEzSYjSCLZ8az9S9nG3yw/iyJMzZWHB7rYEdabgcy76lx7e3of+MRQdYTqG72OKKw0IHHzvRGDVQXWYBDU';
export const GENERATE_PROCESS_API_KEY =
  'Bearer za-U2FsdGVkX18NMKfpUVKKSHTSS0R7OXPsQPRy9kxIhA329UZ1BsB8NzVudjW+4WSu/5kcmmThbr9I+64IYWcRUd6gAzt5VqbH3OD7vy/VUrqOrVUq0bkXTtDpV1MMBuLq';

export const EVALUATE_IDEATION_API_KEY =
  'Bearer za-U2FsdGVkX1/ttZ/pUsCjolOeYbHP4uWJKYu0O860+8yYE6ebW6DvrABLSug5Qkw4DIVv+2HmxvP3kq9t+WtL3P4Wt1KaaAc43piiuclp840Ek1C9ibGtQGD44w9fTXuK';

export const ENVIRONMENT = import.meta.env.MODE;
